/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function onLoad(event, element) {
  window.invokePreload.onLoad(element, "success");
  element.dispatchEvent(new CustomEvent("load", event || {}));
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/

function onError(preloadState, element) {
  window.invokePreload.onLoad(element, preloadState);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/

function timeoutPromise(ms, promise) {
  return new window.Promise((resolve, reject) => {
    setTimeout(() => reject(new Error("timeout")), ms);
    promise.then(resolve, reject);
  });
}

/*🤫*/

const TIMEOUT = 3000;
/*🤫
🤫
🤫
🤫
🤫
🤫*/

function loadWithFetch(element) {
  const options = {
    method: "GET",
    mode: "cors",
    cache: "force-cache"
  }; /*🤫*/

  return timeoutPromise(TIMEOUT, window.fetch(element.href, options)).then(response => {
    if (response.ok) {
      onLoad(null, element);
    } else if (response.status === 404) {
      onError("error", element);
    } else {
      onError("try-with-error", element);
    }
  }).catch(() => onError("try-with-error", element));
}

/*🤫
🤫
🤫
🤫
🤫*/

function loadImage(element) {
  const img = new Image();

  img.onload = event => onLoad(event, element);

  img.onerror = () => onError("error", element);

  img.src = element.href;
  return img;
}
/*🤫
🤫
🤫
🤫
🤫*/

function loadFont(element) {
  if (!document.fonts) {
    /*🤫*/
    return loadWithFetch(element);
  } /*🤫*/


  if (!element.hasAttribute("name")) {
    return loadWithFetch(element);
  } /*🤫*/


  const f = new FontFace(element.getAttribute("name"), `url(${element.href})`, {
    weight: element.getAttribute("weight") || "normal",
    style: "normal"
  });
  return f.load().then(loadedFace => {
    /*🤫*/
    /*🤫*/
    document.fonts.add(loadedFace);
    onLoad(null, element);
  }).catch(function () {});
}
/*🤫
🤫
🤫
🤫*/

function loadStyle(element) {
  window.invokePreload.onLoad(element, "success");
  window.invokePreload.onStyleLoad(element);
}
/*🤫
🤫
🤫
🤫
🤫*/

function loadScript(element) {
  return loadWithFetch(element);
}

/*🤫
🤫
🤫
🤫
🤫
🤫*/

function preloadElement(element) {
  switch (element.getAttribute("as")) {
    case "script":
      return loadScript(element);

    case "image":
      return loadImage(element);

    case "style":
      return loadStyle(element);

    case "font":
      return loadFont(element);

    default:
      return loadWithFetch(element);
  }
}

/*🤫
🤫
🤫
🤫*/

if (!window.invokePreload.browserSupport.preload) {
  window.invokePreload.preloadElement = preloadElement;
}
/*🤫*/
